// extracted by mini-css-extract-plugin
export var borderTop = "navigation-customer-dr-module--border-top--f00c9";
export var iconLogin = "navigation-customer-dr-module--icon-login--47fb9";
export var iconLogout = "navigation-customer-dr-module--icon-logout--d486f";
export var navigationItem = "navigation-customer-dr-module--navigation-item--8cb73";
export var navigationItemActive = "navigation-customer-dr-module--navigation-item-active--672ba";
export var navigationItemHeadline = "navigation-customer-dr-module--navigation-item-headline--8afd6";
export var navigationItemWrapper = "navigation-customer-dr-module--navigation-item-wrapper--d4269";